const DEFAULT_REQUEST_TIMEOUT_MS = 15_000

function readBooleanFlag(rawValue: string | undefined): boolean {
  return rawValue?.trim().toLowerCase() === 'true'
}

function readPositiveInteger(rawValue: string | undefined, fallbackValue: number): number {
  const parsedValue = Number.parseInt(rawValue ?? '', 10)
  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : fallbackValue
}

/**
 * The only place allowed to read `import.meta.env`. Business code imports `env` instead,
 * so every variable is parsed, defaulted and typed exactly once.
 */
export const env = Object.freeze({
  appEnvironment: import.meta.env.VITE_APP_ENV,
  appTitle: import.meta.env.VITE_APP_TITLE,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  requestTimeoutMs: readPositiveInteger(
    import.meta.env.VITE_REQUEST_TIMEOUT_MS,
    DEFAULT_REQUEST_TIMEOUT_MS,
  ),
  isTelegramMockEnabled: readBooleanFlag(import.meta.env.VITE_TELEGRAM_MOCK),
  isDebugEnabled: readBooleanFlag(import.meta.env.VITE_DEBUG),
  isProduction: import.meta.env.PROD,
})
